import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import { GlobalRespo, GlobalResponseData } from '../../../services/raintree/interfaces/global-respo';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DpLoaderComponent } from "../../../common-component/dp-loader/dp-loader.component";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
@Component({
  selector: 'app-global-search-tab-responsive',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    FormsModule, MatTooltipModule, ClipboardModule, InfiniteScrollModule,
    LoaderComponent, DpLoaderComponent],
  templateUrl: './global-search-tab-responsive.component.html',
  styleUrl: './global-search-tab-responsive.component.scss'
})
export class GlobalSearchTabResponsiveComponent {
  responseData: any = [];
  @Input() data: any;
  name = new FormControl();
  isLoader:boolean= false;
  pageNo = 1;
  pageSize=200;
  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();
  noDataFound: boolean=false;
  constructor(private _masterSearchService: MasterSearchTransmissionService) {}

  ngOnInit(): void {
    this.name.patchValue(this.data.name);
    this.responseData = this.data.masterSearchData;
    console.log(this.responseData)
  }
  onMasterSearch(isStart:boolean) {
    if(isStart){
      this.isLoader=true;
      this.pageNo=1;
      this.responseData=[];
    }

    this._masterSearchService
      .fetchGlobalSearchRecords(this.name.value,this.pageNo,this.pageSize)
      .subscribe({
        next: (response: GlobalResponseData) => {
          this.isLoader = false;
          this.noDataFound = false;

          if (response.data.memberList.length == 0) { 
            this.isLoader = false;
            if(isStart){
              this.noDataFound=true;
            }
          }
          else{
            this.responseData = [...this.responseData,...response.data.memberList.map(
              (user: GlobalRespo) => {
                return {
                  slNo: user.mk,
                  fullName: user.fn + ' ' + user.ln,
                  district: user.dn,
                  memberStatus: 'FW Pending',
                  guardianFullName: user.gfn + ' ' + user.gln,
                  initiationDate: user.md,
                  ritwik: user.rn,
                  pincode: user.pn,
                  address: user.add,
                };
              }
            )];
          }
          
        },
        error: (error) => {
          console.log(error);
          this.isLoader=false;
        },
      });
  }

  onScroll(){
    console.log('scroll event occured')
    this.pageNo+=1;
    this.onMasterSearch(false);
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }
}
